import React, { Component } from 'react';
import moment from 'moment';
import SmartStudyLogo from '../images/smart_study_logo.svg';
import AccountCircle from '../images/account_circle.svg';
import LineVertical from '../images/line_vertical.svg';
import Menu from '../images/menu.svg';
import CloseFilled from '../images/CloseFilled.svg';
import ItemList from '../components/ItemList';
import { DEFAULT_DATE_FORMAT_SERVER_NO_SECOND } from '../constants';
import * as FUNCTION from '../constants/FunctionConstants';
import { SUPERUSER_LOGIN_TYPE } from '../constants/CommonConstants';
import { checkShowLogo } from '../utils/PageUtils';

function TopNavigator(props) {
  const {
    panelData,
    collapseSubMenu,
    showSubMenu,
    topNavigatorDatas,
    url,
    logout,
    hiddenStatus,
    isShowContract,
    isTrialExpire,
    openInquiry,
    openFaqPage,
    redirectToServicePage,
    authedUser,
  } = props;
  const menu = topNavigatorDatas.map((itemData) => {
    const { id, path } = itemData;
    if (itemData.id === FUNCTION.LOGOUT) {
      return <ItemList data={itemData} logout={logout} />;
    }
    // Step 11.0.0 START
    if (itemData.id === FUNCTION.CONTACT || itemData.id === FUNCTION.FAQ) {
      const targetOpenPage = itemData.id === FUNCTION.CONTACT ? openInquiry : openFaqPage;
      return (
        <ItemList
          data={itemData}
          openPage={targetOpenPage}
          hiddenStatus={hiddenStatus}
          isShowContract={isShowContract}
          isTrialExpire={isTrialExpire}
          isOEMUser={panelData.isOEMUser}
        />
      );
    }
    // Step 11.0.0 END
    return <ItemList key={id} data={itemData} url={url} />;
  });

  return (
    <>
      {checkShowLogo(authedUser) && (
        <div className="top-navigator-logo" onClick={redirectToServicePage}>
          <img className="cursor_pointer" src={SmartStudyLogo} alt="smart study logo" />
        </div>
      )}
      <div className="top-navigator-enterprise">
        <span className="cursor_pointer" onClick={redirectToServicePage}>{panelData.enterpriseName}</span>
      </div>
      <div className="top-navigator-superuser-datetime">
        <div className="top-navigator-superuser">
          <img src={AccountCircle} alt="account circle logo" />
          <span>{panelData.userName}</span>
        </div>
        <i>
          <p className="lastLoginTime">
            最終ログイン日時{" "}
            {panelData.lastLoginTime
              ? moment(panelData.lastLoginTime).format(DEFAULT_DATE_FORMAT_SERVER_NO_SECOND)
              : "ログイン履歴なし"}
          </p>
        </i>
      </div>
      <div className="line-vertical">
        <img src={LineVertical} alt="line vertical" />
      </div>
      <div id="top-navigator-dropdown-menu-button">
        <button onClick={collapseSubMenu}>
          <img id="topMenuBtn"src={showSubMenu ? CloseFilled : Menu} alt="menu" />
        </button>
      </div>
      {showSubMenu && (
        <div id="top-navigator-dropdown-menu">
          <ul className="sub-menu-list">{menu}</ul>
        </div>
      )}
    </>
  );
}

export default TopNavigator;
